export function isInt(value: number): boolean {
  return value % 1 === 0;
}

export function avg(...values: number[]): number {
  return values.reduce((a, b) => a + b, 0) / values.length;
}

export function bound(number: number, min: number, max: number): number {
  return Math.max(Math.min(number, max), min);
}

/**
 * Clamps a number within optional bounds. If `bounds` is a single number, it is treated as the minimum.
 */
export function clamp(n: number, bounds?: number | [number, number]): number {
  n = Number.isNaN(n) ? 0 : n;

  if (bounds === undefined) {
    return n;
  } else if (typeof bounds === 'number') {
    const min = bounds;
    return Math.max(min, n);
  } else {
    const [min, max] = bounds;
    return Math.max(min, Math.min(n, max));
  }
}

export function mod(number: number, mod: number) {
  return ((number % mod) + mod) % mod;
}

export function gcd(a: number, b: number) {
  a = Math.abs(Math.round(a));
  b = Math.abs(Math.round(b));
  // Guard against non-finite input (NaN/Infinity): without this the recursion
  // never terminates because NaN % NaN === NaN never reaches the b === 0 base case.
  if (!Number.isFinite(a) || !Number.isFinite(b)) return NaN;
  if (b == 0) return a;
  else return gcd(b, a % b);
}
